const scenarios = [
  {
    icon: 'ri-database-2-line',
    situation: 'Компания внедряет CRM, но менеджеры продолжают работать по старой схеме.',
    logic: 'Проблема не в программе, а в том, что не изменились привычки. Сначала разбираемся, почему менеджеры не пользуются системой, затем показываем, какую задачу она решает, обучаем и закрепляем новую практику через контроль и обратную связь.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    situation: 'Руководство изменило KPI, а сотрудники считают новую систему несправедливой.',
    logic: 'Сопротивление — это сигнал о том, что логика изменений не была донесена. Объясняем, какую проблему решает новая система, слушаем опасения, отделяем факты от эмоций и ищем решение, которое понятно и руководству, и команде.',
  },
  {
    icon: 'ri-bar-chart-2-line',
    situation: 'Компания быстро растёт, а старые управленческие процессы перестают работать.',
    logic: 'Здесь нужно не просто добавить новые правила, а перестроить систему управления: распределить ответственность, зафиксировать новые стандарты и подготовить руководителей к работе в изменившихся условиях.',
  },
  {
    icon: 'ri-user-star-line',
    situation: 'Новый руководитель пытается изменить команду, но сталкивается с сопротивлением.',
    logic: 'Команда не доверяет тому, чего не понимает. Руководителю важно сначала понять существующие правила и опасения, затем объяснить причины изменений и постепенно выстраивать доверие, а не требовать немедленного подчинения.',
  },
  {
    icon: 'ri-file-list-3-line',
    situation: 'Внедряется новый стандарт работы, но сотрудники воспринимают его как формальность.',
    logic: 'Стандарт из документа превращается в поведение только через практику и контроль. Разбираем, почему стандарт не прижился, обучаем, даём практику и закрепляем новое поведение в процессах, чтобы оно перестало быть формальностью.',
  },
  {
    icon: 'ri-organization-chart',
    situation: 'Несколько подразделений должны перейти на новый процесс, но каждое защищает привычный способ работы.',
    logic: 'Здесь конфликт интересов подразделений. Нужно выявить, что стоит за защитой старого способа, показать общую цель и последствия сохранения статус-кво, и договориться о единых правилах взаимодействия.',
  },
];

export default function PracticalSituations() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Практические ситуации
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Какие ситуации можно разбирать на обучении — реальные сценарии, с которыми сталкиваются компании
        </p>

        <div className="space-y-5">
          {scenarios.map((s) => (
            <div key={s.situation} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${s.icon} text-teal-700 text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-sm mb-2">{s.situation}</h3>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    <span className="font-semibold text-teal-700">Управленческая логика: </span>
                    {s.logic}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}